export const searchFormEnLocale = {
  'events.search': 'Search',
  'events.searchPlaceholder': 'Search by artist, event or venue',
  'events.category': 'Category',
  'events.categoryAll': 'All categories',
  'events.categoryConcerts': 'Concerts',
  'events.categoryArts': 'Arts',
  'events.categorySports': 'Sports',
  'events.categoryEntertainment': 'Entertainment',
  'events.dateRange': 'Date range',
  'events.selectDateRange': 'Select date range',
} as const;

export const searchFormEsLocale = {
  'events.search': 'Buscar',
  'events.searchPlaceholder': 'Buscar por artista, evento o recinto',
  'events.category': 'Categoría',
  'events.categoryAll': 'Todas las categorías',
  'events.categoryConcerts': 'Conciertos',
  'events.categoryArts': 'Artes',
  'events.categorySports': 'Deportes',
  'events.categoryEntertainment': 'Familiar',
  'events.dateRange': 'Rango de fechas',
  'events.selectDateRange': 'Selecciona un rango de fechas',
} as const;
